import styled from "styled-components";
import { Text } from "@aidron/aidron-ds";

const colors = [
  { name: "orange", code: "#e75d0d" },
  { name: "mediumGrey", code: "#5f5e5e" },
  { name: "white", code: "#ffffff" },
  { name: "orangeGrey", code: "#b19585" },
  { name: "darkYellow", code: "#c9a91ee6" },
  { name: "red", code: "#CB003A" },
  { name: "blue", code: "#0896a0" },
  { name: 'darkBlue', code: '#374151' },
  { name: "lightGrey", code: "#999" },
  { name: "black", code: "#000" },
  { name: 'charcoalGray', code: '#333' }
];

function getColor(name) {
  const code = colors.find(color => color.name === name)?.code;
  return code ?? "";
}

export const CustomText = styled(Text)`
  color: ${({ color }) => getColor(color)};
  min-height: ${({ minHeight }) => (minHeight ? "29px" : "0px")};
  margin: ${({ margin }) => margin ?? ""};
  padding: ${({ padding }) => padding ?? ""};
  text-align: ${({ textAlign }) => textAlign ?? ""};
  line-height: ${({ lineHeight }) => lineHeight ?? ""};
  display: ${({ display }) => display ?? ""};
  text-decoration: ${({ textDecoration }) => textDecoration ?? ""};
  font-weight: ${({ weight }) => (weight === "bold" ? "600" : "400")};
  white-space: ${({ whiteSpace }) => whiteSpace ?? ""};
  inline-size: ${({ inlineSize }) => inlineSize ?? ""};
  max-inline-size: ${({ maxInlineSize }) => maxInlineSize ?? ""};
  background-color: ${({ backgroundColor }) => backgroundColor ?? ""};

  font-size: ${({ fontSize, size }) => {
    if (fontSize && Array.isArray(fontSize) && fontSize.length === 3) {
      const [min, preferred, max] = fontSize;
      const numericPreferred = parseFloat(preferred);
      const growthFactor = numericPreferred * 0.6;
      const result = `clamp(${min}, calc(${preferred} + ${growthFactor}vw), ${max})`;
      return result;
    }
    
    if (size) {
      const numericValue = parseFloat(size);
      const unit = size.replace(numericValue.toString(), '');
      if (!isNaN(numericValue) && unit) {
        const minValue = Math.max(numericValue * 0.75, numericValue - 4);
        const maxValue = numericValue * 1.25;
        const growthFactor = numericValue * 0.1;
        
        return `clamp(${minValue}${unit}, calc(${size} + ${growthFactor}vw), ${maxValue}${unit})`;
        }
      return size;
    }
    return "clamp(12px, calc(14px + 1vw), 20px)";
  }}; 
  && {
    font-size: ${({ fontSize, size }) => {
      if (fontSize && Array.isArray(fontSize) && fontSize.length === 3) {
        const [min, preferred, max] = fontSize;
        const numericPreferred = parseFloat(preferred);
        const growthFactor = numericPreferred * 0.6;
        return `clamp(${min}, calc(${preferred} + ${growthFactor}vw), ${max}) !important`;
      }
      if (size) {
        const numericValue = parseFloat(size);
        const unit = size.replace(numericValue.toString(), '');
        
        if (!isNaN(numericValue) && unit) {
          const minValue = Math.max(numericValue * 0.75, numericValue - 4);
          const maxValue = numericValue * 1.25;
          const growthFactor = numericValue * 0.5;
          
          return `clamp(${minValue}${unit}, calc(${size} + ${growthFactor}vw), ${maxValue}${unit}) !important`;
        }
        return `${size} !important`;
      }
      
      return "clamp(12px, calc(14px + 1vw), 20px) !important";
    }};
  }
`;